var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"row-mask"},_vm._l((_vm.row.columns),function(col){return _c('td',{key:col.colId},[_c('Column',{attrs:{"col":col,"row":_vm.row},on:{"colClick":_vm.clickHandler}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }